import { faMeta } from '@fortawesome/free-brands-svg-icons';
import { faRectangleAd } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SimpleGrid } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TChannel } from '@feathr/blackbox';
import { SelectableCard } from '@feathr/components';

interface IChooseChannelContentProps {
  selectedChannel: TChannel | undefined;
  onChannelSelect: (channel: TChannel) => void;
  /** Available channels to display. If undefined, shows all channels. */
  availableChannels?: TChannel[];
}

function ChooseChannelContent({
  selectedChannel,
  onChannelSelect,
  availableChannels,
}: Readonly<IChooseChannelContentProps>): JSX.Element {
  const { t } = useTranslation();

  function handleSelectDisplay(): void {
    onChannelSelect('display');
  }

  function handleSelectMeta(): void {
    onChannelSelect('meta');
  }

  const showDisplay = !availableChannels || availableChannels.includes('display');
  const showMeta = !availableChannels || availableChannels.includes('meta');
  const visibleCount = (showDisplay ? 1 : 0) + (showMeta ? 1 : 0);

  return (
    <SimpleGrid cols={visibleCount}>
      {showDisplay && (
        <SelectableCard
          checked={selectedChannel === 'display'}
          contentOrientation={'vertical'}
          data-name={'channel-display'}
          name={'channel'}
          onChange={handleSelectDisplay}
          prefix={<FontAwesomeIcon icon={faRectangleAd} />}
          showPrefixBackground={false}
          theme={'cyan'}
          title={t('Display Ad')}
          value={'display'}
        />
      )}
      {showMeta && (
        <SelectableCard
          checked={selectedChannel === 'meta'}
          contentOrientation={'vertical'}
          data-name={'channel-meta'}
          name={'channel'}
          onChange={handleSelectMeta}
          prefix={<FontAwesomeIcon icon={faMeta} />}
          showPrefixBackground={false}
          theme={'cyan'}
          title={t('Meta')}
          value={'meta'}
        />
      )}
    </SimpleGrid>
  );
}

export default ChooseChannelContent;
